<template>
  <div class="word-list20">
    <div
      class="head"
      :style="{
        backgroundImage: 'url(' + dataInfo.cover + ')'
      }"
    >
      {{ dataInfo.name }}
    </div>
    <div class="g-box">
      <div class="content">
        <div class="item" v-for="item in list" :key="item.id">
          <kf-video
            class="video"
            :src="item.video"
            :muted="true"
            :controls="true"
            :preload="true"
            :fluid="true"
            v-if="item.video"
          />
          <div class="title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";
import kfVideo from "../../components/kf-video";
export default {
  data() {
    return {
      query: this.$route.query,
      dataInfo: {},
      params: {},
      pageSize: 15,
      dataList: {}
    };
  },
  mixins: [pageMain_mx],
  components: { kfVideo },
  mounted() {},
  methods: {
    async init() {
      this.params = this.$route.params;
      this.pageNum = 1;
      this.getAjax();
      const dataInfo = await this.getMenuInfo(this.params.menuId);
      this.dataInfo = dataInfo;
      console.log(dataInfo, "dataInfo", this.list, "list");
    },
    getAjax() {
      this.getList();
    }
  }
};
</script>
<style lang="less">
.word-list20 {
  .head {
    height: 280px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 60px;
    color: #fff;
    letter-spacing: 40px;
  }
  .content {
    padding-top: 80px;
    padding-bottom: 110px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .item {
      margin-bottom: 40px;
      .video {
        width: 580px;
        height: 320px;
        background: #d8d8d8;
        overflow: hidden;
      }
      .title {
        padding-top: 16px;
        font-size: 28px;
        font-weight: 500;
        color: #000000;
        line-height: 40px;
      }
    }
  }
}
</style>
